import React from "react";
import SidebarMenuItem from "./SidebarMenuItem";

const SidebarMenu = ({ menuConfig, toggleMenu, activeMenu, closeSidebar, isVoucherCustomer }) => {
  return (
    <>
      {menuConfig.map((menu, index) => (
        <SidebarMenuItem
          key={index}
          menu={menu}
          toggle={() => toggleMenu(menu.title)}
          isOpen={activeMenu === menu.title} // Only open if it's the active menu
          activeMenu={activeMenu}
          closeSidebar={closeSidebar}
          isVoucherCustomer={isVoucherCustomer}
        />
      ))}
    </>
  );
};

export default SidebarMenu;
